import { Link } from 'react-router-dom'
import { WHY_CHOOSE_FEATURES } from './whyChooseData.jsx'

export default function WhyChooseSection() {
  return (
    <section className="relative overflow-hidden bg-linear-to-b from-background to-white py-16 md:py-24 md:px-18">
      <div className="pointer-events-none absolute left-1/2 top-0 h-72 w-72 -translate-x-1/2 rounded-full bg-secondary/8 blur-3xl" />
      <div className="container relative z-10 mx-auto px-6 max-w-350">
        <div className="mx-auto mb-14 flex max-w-2xl flex-col items-center text-center">
          <div className="flex items-center gap-3">
            <span className="h-px w-8 bg-secondary/50" />
            <span className="text-[10px] uppercase tracking-[0.4em] text-secondary">Why Choose Us</span>
            <span className="h-px w-8 bg-secondary/50" />
          </div>
          <h2 className="mt-3 font-cinzel text-3xl uppercase leading-tight text-primary md:text-4xl lg:text-5xl">
            Guidance You Can <span className="text-gradient-gold">Truly Trust</span>
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-primary/55 md:text-base normal-case">
            Thousands of seekers turn to us for honest, accurate and confidential Vedic guidance — here&apos;s what makes every consultation count.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {WHY_CHOOSE_FEATURES.map((feature) => (
            <div
              key={feature.title}
              className="group relative overflow-hidden rounded-3xl border border-border/50 bg-white p-7 shadow-sm transition-all duration-400 hover:-translate-y-1.5 hover:border-secondary/40 hover:shadow-xl hover:shadow-primary/5"
            >
              <span className="grid h-14 w-14 place-items-center rounded-2xl bg-primary/5 text-primary ring-1 ring-border/50 transition-all duration-400 group-hover:bg-secondary group-hover:text-white group-hover:ring-secondary">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
                  {feature.icon}
                </svg>
              </span>
              <h3 className="relative z-10 mt-5 font-cinzel text-lg leading-tight text-primary transition-colors group-hover:text-secondary">{feature.title}</h3>
              <p className="relative z-10 mt-2 text-[13px] leading-relaxed text-primary/55 normal-case">{feature.desc}</p>
              <span className="absolute bottom-0 left-0 h-1 w-0 bg-linear-to-r from-secondary to-secondary transition-all duration-500 group-hover:w-full" />
            </div>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <Link
            to="/maharaj-ji"
            className="inline-flex items-center justify-center whitespace-nowrap focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 active:scale-95 py-2 group h-12 rounded-full bg-primary px-8 text-[11px] font-semibold uppercase tracking-[0.2em] text-white shadow-lg shadow-primary/20 transition-all hover:bg-secondary"
          >
            Talk to an Astrologer
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1">
              <path d="M5 12h14" />
              <path d="m12 5 7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  )
}
